import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applyCoupon, clearCoupon } from "../../../redux/couponSlice";
import { toast } from 'react-toastify'
const ApplyCoupon = ({ cartTotal, getUserCouponCode }) => {
  const dispatch = useDispatch();
  const { discount, newTotal, loading, error } = useSelector((state) => state.coupon);
  const [couponCode, setCouponCode] = useState("");
  const [finalAmount, setFinalAmount] = useState(newTotal);

  const sendData = (e) => {
    setCouponCode(e.target.value);
    getUserCouponCode({ couponCode: e.target.value, finalAmount, discount });
  };

  const handleApplyCoupon = () => {
    if (!couponCode) return;
    dispatch(applyCoupon({ code: couponCode, cartTotal })).then((res) => {
      if (res.type === "coupon/applyCoupon/fulfilled") {
        console.log(res.payload);
        setFinalAmount(res.payload.newTotal);
        getUserCouponCode({ couponCode, finalAmount: res.payload.newTotal, discount: res.payload.discount });
        toast.success("Coupon applied successfully");
        setFinalAmount("")
      }
    });
  };

  const handleRemoveCoupon = (e) => {
    e.preventDefault();
    dispatch(clearCoupon());
  };

  return (
    <>
      <div className="mb-3 d-flex align-items-center justify-content-between">
        <input
          type="text"
          placeholder="Enter coupon code"
          value={couponCode}
          // onChange={(e) => setCouponCode(e.target.value)}
          onChange={sendData}
          className="form-control"
        />
        <button className="btn btn-primary text-nowrap" onClick={handleApplyCoupon} disabled={loading}>
          {loading ? "Applying..." : "Apply Coupon"}
        </button>
      </div>
      {error && <p className="w-100 d-flex flex-column text-danger line-height-1">{error}</p>}
      {discount > 0 && (
        <div className="w-100 d-flex flex-column">
          <p className="text-success">Discount Applied: Rs. {discount?.toFixed(2)}</p>
          {/* <p>New Total: Rs. {finalAmount}</p> */}
          <button className="mx-auto mb-3 d-flex w-50 btn btn-danger btn-sm align-items-center justify-content-center" onClick={(e) => handleRemoveCoupon(e)}>Remove Coupon</button>
        </div>
      )}
    </>
  );
};

export default ApplyCoupon;
